import { FC, ReactNode } from "react"

import { Stack } from "@mui/material"
import { useIsBreakpointUp } from "hooks/breakpoint"

interface IDialogFooterProps {
  children: ReactNode
}

const DialogFooter: FC<IDialogFooterProps> = ({ children }) => {
  const isTablet = useIsBreakpointUp("tablet")

  return (
    <Stack
      direction={isTablet ? "row" : "column-reverse"}
      gap={1.25}
      justifyContent="end"
      pt={2}
      sx={(theme) => ({
        borderTop: `1px solid ${theme.palette.mockup.primary95}`,
      })}
    >
      {children}
    </Stack>
  )
}

export default DialogFooter
